import React from "react";
import { useStyles } from "./styles";

export const StatisticWidgetCell = ({ children, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);

  return (
    <div className={classes.cell} ref={ref}>
      {children}
    </div>
  );
};
StatisticWidgetCell.muiName = "StatisticWidgetCell";
StatisticWidgetCell.displayName = "StatisticWidgetCell";

export default StatisticWidgetCell;
